import { render } from "./cloudU.vue?vue&type=template&id=6ec7d924"
import script from "./cloudU.vue?vue&type=script&lang=js"
export * from "./cloudU.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\amaan\\encanto-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__